export default {
	allinone: "https://d2z53scj8veve3.cloudfront.net/shopdeck-home/help-you-succeed-all-in-one.svg",
	winwin: "https://d2z53scj8veve3.cloudfront.net/shopdeck-home/help-you-succeed-win-win-approach.svg",
	profitfocused: "https://d2z53scj8veve3.cloudfront.net/shopdeck-home/help-you-succeed-profit-focused-account-management.svg"
}
